export class StartSparkJobDirectParams {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobTimeout",
            "baseName": "jobTimeout",
            "type": "number",
            "format": ""
        },
        {
            "name": "retryPolicy",
            "baseName": "retryPolicy",
            "type": "SparkJobRetryPolicy",
            "format": ""
        },
        {
            "name": "sparkSubmitParams",
            "baseName": "sparkSubmitParams",
            "type": "SparkJobSparkSubmitParams",
            "format": ""
        },
        {
            "name": "storageConfig",
            "baseName": "storageConfig",
            "type": "StorageConfig",
            "format": ""
        },
        {
            "name": "comet",
            "baseName": "comet",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StartSparkJobDirectParams.attributeTypeMap;
    }
    constructor() {
    }
}
